import types from "./types";

import { request } from "api/actions";
import { AxiosRequestConfig } from "axios";

export const restaurantsFetch = (config?: AxiosRequestConfig) =>
    request(
        types.FETCH_REQUEST,
        types.FETCH_FAILED,
        types.FETCH_SUCCESS,
        "restaurantsFetch",
        { config },
        undefined,
        undefined,
        "booking",
    );

export const restaurantsGet = (
    id: number,
    config?: AxiosRequestConfig,
    onResponse?: Function,
) =>
    request(
        types.GET_REQUEST,
        types.GET_FAILED,
        types.GET_SUCCESS,
        "restaurantsGet",
        {
            config,
            url: {
                id,
            },
        },
        onResponse,
        undefined,
        "booking",
    );

export const restaurantsTableUpdate = (action: string, data: any) => ({
    type: types.TABLE_UPDATE,
    action,
    data,
});
